import contactsReducer from './reducer';
import * as contactsActions from './reducer';

export { contactsActions };

export default contactsReducer;
